module.exports = __webpack_public_path__ + "assets/img/y_15.0bea1a70.png";